import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {init as initKeycloak} from "./security/keycloak";
import Buefy from 'buefy';

Vue.config.productionTip = false

Vue.use(Buefy, {
    defaultIconPack: 'fa',
    defaultDateFormatter: date => {
        if (Array.isArray(date)) {
            if (date.length > 0) {
                return date[0].toLocaleDateString('hu-hu') + " - " + date[1].toLocaleDateString('hu-hu');
            }
            return null;
        } else {
            return date.toLocaleDateString('hu-hu');
        }
    }
});

initKeycloak()
    .then(() => {
        new Vue({
            router,
            render: h => h(App),
        }).$mount('#app')
    })
